module.exports = __webpack_public_path__ + "static/img/level-card-banner1.81abc90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/3/level-card-banner1.png
// module id = o0rz
// module chunks = 1